module.exports = __webpack_public_path__ + "img/yhsss.5ff76fc4.png";